const emphasizedLabelKeys = new Set([
  'contact number',
  'date of birth',
  'gender',
  'occupation trade',
  'are you a politically exposed person pep',
  'drivers license issue date',
  'country of issue',
  'select the year your vehicle was manufactured',
  'is your vehicle',
  'vehicle type of body',
  'vehicle make model',
  'fuel type',
  'cubic capacity rating cc rating',
  'no of seats',
  'type of coverage',
  'does your vehicle have an alarm',
  'state alarm type',
  'has your motor vehicle been modified in any way or fitted with oversized tyres or a high performance engine or any intention to do so',
  'have you ever had motor vehicle insurance in your name',
  'you anyone using your vehicle ever had a claim',
  'what will your vehicle be used for',
  'is your vehicle subject to a loan',
  'will anyone under the age of 25 and or with a driver permit issued less than 2 years be driving the vehicle',
  'drivers date of birth',
  '1 drivers date of birth',
  '2 drivers date of birth',
  '3 drivers date of birth',
  '4 drivers date of birth',
  'issue date of drivers license',
  '2 issue date of drivers license',
  '3 issue date of drivers license',
  '4 issue date of drivers license',
  'state the duration of your loan',
  'select branch',
  'state finance company',
  'select job category',
  'select industry',
  'street address',
  'mailing address',
  'home address',
  'where is the vehicle housed mainly at night',
  'how many years ago',
  'duration of no claim period',
  'how many years',
  'state the insurance company',
  'are you the only registered owner of this vehicle',
  'where is your vehicle parked mainly at night',
  'select age group',
  'beneficiarys date of birth',
  'relationship',
]);

const normalizeLabelText = label => {
  if (!label) {
    return '';
  }

  return label
    .toString()
    .toLowerCase()
    .replace(/['’]/g, '')
    .replace(/[^\w]+/g, ' ')
    .trim();
};

export const shouldEmphasizeLabel = label => {
  const normalizedLabel = normalizeLabelText(label);
  if (!normalizedLabel) {
    return false;
  }

  return emphasizedLabelKeys.has(normalizedLabel);
};
